let EstadosCertificado = {
    Solicitado: 1,
    PendientePago: 4,
    Completado: 3,
    Rechazado: 5,
    Atendido: 9,
}

export {
    EstadosCertificado
}